export default __webpack_public_path__ + "static/media/chimney_blue.2efda3e7.svg";